var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9375 12.624C8.33594 12.624 8.66406 12.2959 8.66406 11.9131V4.0459L8.60156 2.88184L9.08594 3.45215L10.1875 4.62402C10.3125 4.76465 10.4922 4.83496 10.6719 4.83496C11.0234 4.83496 11.3125 4.57715 11.3125 4.20996C11.3125 4.02246 11.2422 3.88184 11.1094 3.74902L8.48438 1.22559C8.30469 1.03809 8.13281 0.975586 7.9375 0.975586C7.75 0.975586 7.57812 1.03809 7.39844 1.22559L4.77344 3.74902C4.64062 3.88184 4.5625 4.02246 4.5625 4.20996C4.5625 4.57715 4.85156 4.83496 5.20312 4.83496C5.38281 4.83496 5.57031 4.76465 5.69531 4.62402L6.78906 3.45215L7.28125 2.88184L7.21875 4.0459V11.9131C7.21875 12.2959 7.54688 12.624 7.9375 12.624ZM3.44531 18.8506H12.4375C14.125 18.8506 15 17.9834 15 16.3193V8.62402C15 6.95996 14.125 6.09277 12.4375 6.09277H10.3203V7.62402H12.3438C13.0625 7.62402 13.4688 7.99902 13.4688 8.75684V16.1865C13.4688 16.9443 13.0625 17.3193 12.3438 17.3193H3.53906C2.8125 17.3193 2.41406 16.9443 2.41406 16.1865V8.75684C2.41406 7.99902 2.8125 7.62402 3.53906 7.62402H5.57812V6.09277H3.44531C1.75781 6.09277 0.882812 6.95996 0.882812 8.62402V16.3193C0.882812 17.9834 1.75781 18.8506 3.44531 18.8506Z",
    fill: "#2EA7E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3747f69b.svg";
export { ForwardRef as ReactComponent };